<script>
export default {
  data() {
    return {
      request_data: {}
    }
  },
  methods: {
    handleLineClass(row) {
      if(row.count == (row.max-1)){
        return 'custom-line-warning'
      }
      else if (row.count >= row.max) {
        return 'custom-line-danger'
      } else {
        return  ''
      }
    }
  },
  mounted() {
    let success = resp => {
      if(resp.success) {
        this.request_data = resp.data
      } else {
        fail(resp)
      }
    }
    let fail = resp => {
      console.log(resp)
    }

    this.$getLicenseCopier().then(success, fail)
  }
}
</script>

<template>
  <div class="card">
    <div class="card-header">
      <h5>
        <i class="fa fa-desktop"></i>
        License
      </h5>
      <hr>
    </div>
    <div class="card-body">
      <div class="col-md-12">
        <table class="table">
  <thead>
  <tr>
    <th>{{ $t('license') }} </th>
    <th class="text-center">{{ $t('revalidations_counter') }} <small>({{ $t('max') }})</small></th>
  </tr>
  </thead>
  <tbody>
  <tr v-for="item in request_data">
    <td>
      <strong>{{ item.license }}</strong>
    </td>
    <td class="text-center" :class="handleLineClass(item)">
      <strong>{{ item.count }}</strong> <small class="ml-1">({{ item.max }})</small>
    </td>
  </tr>
  </tbody>
  </table>
      </div>
  </div>
  </div>
</template>

<style scoped>
  .custom-line-warning {
    font-weight: bold;
    color: #ffd507;
  }
  .custom-line-danger {
    font-weight: bold;
    color: #ff4646;
  }

</style>
